import React from 'react'

const PDPLoader = (props) => {
    return (
    <> 
      <div className="product-detail-page min-vh-100">
        <div className="product-details">
            <div className="container kf-react-container">
              <div className="header-section">
                  <div className="product-details__breadcrumb">
                    <section>
                        <a
                          className="product-details__breadcrumb-link gbh-data-layer"
                          href=""
                          >
                        </a>
                        /
                        <a
                          className="product-details__breadcrumb-link gbh-data-layer"
                          href=""
                          >
                        </a>
                    </section>
                  </div>
              </div>
              <div className="print-overview product-details__overview-block product-info">
                  <div className="product-img-block product-details__image-gallery print-overview-left">
                    <div className="image-reel row">
                        <div className="image-reel__image-thumb-view no-print">
                          <ul className="pl-0 ml-0 image-reel__image-thumb-view-ul">
                              <li className="image-reel__image-list">
                                <div className="image-reel__image-thumb">
                                </div>
                              </li>
                          </ul>
                        </div>
                        <div className="image-reel__image-stack-view">
                          <div className="image-reel__image-stack-view-block">
                              <ul className="pl-0 list-inline image-reel__image-stack-list">
                                <li>
                                </li>
                              </ul>
                          </div>
                          <p className="image-reel__photo-credit"></p>
                        </div>
                    </div>
                  </div>
                  <div className="col-12 product-summary__product-summary-block p-0">
                    <div className="product-summary" id="product-summary-wrapper">
                        <div className="product-summary__title"></div>
                        <div className="product-summary__desc">
                          <span className="product-summary__desc"></span>
                          <span className="product-summary__desc"></span>
                        </div>
                        <>
                        <div className="product-summary__price">
                          <span className="product-summary__price-first"></span>
                          <span className="product-summary__price-sec"></span>
                        </div>
                        <div className="product-summary__discount">
                          <span className="product-summary__discount-price"></span>
                          <span className="product-summary__price-sec"></span>
                          <span className="product-summary__percent-off"></span>
                        </div>
                        </>
                        <div className="product-summary__details"></div>
                        <div className="product-summary__button-block"></div>
                        <div className="product-summary__icons-block">
                          <div className={`product-summary__icons-part-first`}>
                              <span className="product-details__list-text"></span>
                              <div className={`product-details__tooltip-main-block`}>
                                <div className="product-details__list-tooltip-wrapper"></div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </>
)};

export default PDPLoader